import cs from 'classnames'
import React, { FC, ReactNode } from 'react'

import s from './WixMobileDescription.scss'

interface WixMobileDescriptionProps {
  dataHook?: string
  skin?: 'default' | 'harmony'
  children?: ReactNode
}

export const WixMobileDescription: FC<WixMobileDescriptionProps> = ({ children, dataHook, skin = 'default' }) => {
  return (
    <p className={cs(s.description, { [s.harmony]: skin === 'harmony' })} data-hook={dataHook}>
      {children}
    </p>
  )
}
